import React, { useState, useEffect } from "react";

import Skeleton from "@mui/material/Skeleton";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { isMobile } from "react-device-detect";

import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";

import interactionPlugin from "@fullcalendar/interaction";
import { hasError, getError } from "../../services/ServiceHelper";

import {
  createCourseEntry,
  getStudentCoursesForDateRange,
} from "../../services/CourseService";

import { showToast } from "../ATPDialogs";
import CourseDetailsDialog from "../CourseDetailsDialog";

/**
 * signupDate - string yyyy-mm-dd
 */
const StudentCourseGrid = ({ signupDate }) => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const _dayRef = React.createRef();
  const [_isDetailsOpen, setDetailsOpen] = React.useState(false);

  const [_isActivitiesLoaded, setActivitiesLoaded] = React.useState(false);
  const [calendarEvents, setCalendarEvents] = useState([
    {
      title: "Hello",
      start: "2024-08-04 07:00:00",
      end: "2024-08-04 07:30:00",
    },
  ]);

  const [_calendarRatio, setCalendarRatio] = useState(0.84);

  const initCourses = () => {
    setActivitiesLoaded(false);
    getStudentCoursesForDateRange(_school, _jwt, signupDate, signupDate)
      .then((result) => {
        if (hasError(result.data) === true) {
          showToast("E", "Unable to get Courses: ", getError(result.data));
        } else {
          loadCourses(result.data);
        }
      })
      .catch((error) => {
        console.log(error);
        showToast("E", "Unable to get Day.");
      })
      .finally(() => {
        setActivitiesLoaded(true);
      });
  };

  useEffect(() => {
    if (isMobile) {
      setCalendarRatio(0.84);
    } else {
      setCalendarRatio(1.66);
    }

    initCourses();
  }, [_school]);

  const loadCourses = (courses) => {
    const events = [];

    for (const courseObj of courses) {
      const event = createCourseEntry(_school, courseObj);
      events.push(event);
    }

    setCalendarEvents(events);
  };

  const handleEventClick = (info) => {
    // setDetailsOpen(true);
  };

  return (
    <>
      {!_isActivitiesLoaded && <Skeleton animation="wave" />}

      <FullCalendar
        ref={_dayRef}
        initialView="timeGridDay"
        locale="en"
        eventClick={(info) => handleEventClick(info)}
        headerToolbar={{ start: "title", center: "", end: "" }}
        plugins={[interactionPlugin, timeGridPlugin]}
        events={calendarEvents}
        height={"550px"}
        themeSystem="standard"
        aspectRatio={_calendarRatio}
        slotMinTime={"07:00:00"}
        slotMaxTime={"16:01:00"}
        allDaySlot={false}
      />
      <CourseDetailsDialog open={_isDetailsOpen} onClose={() => setDetailsOpen(false)} />
    </>
  );
};

export default StudentCourseGrid;
